import React, { FC, useCallback, useEffect, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, SelectBox } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import { shiftAutoFill } from 'bus/shift/actions';
import { ShiftAutoFill } from 'bus/shift/types';

import { useDispatchPromise } from 'hooks/useDispatchPromise';

type Props = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const initialForm: ShiftAutoFill = {
  date: '',
  type: null,
};

const AutoFillModal: FC<Props> = ({ changeVisible, refresh, visible }) => {
  const dispatch = useDispatchPromise();
  let createGroupValidationRef = useRef<ValidationGroup>(null);
  const [types, setTypes] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const postsDateSource = useCallback(async () => {
    const defaultFilter = [['id', '<>', '0']];
    const result = await $createDataSource('/v1/EmployeeSalary/types', 'id', { defaultFilter }).load();
    setTypes(result.filter((i) => i.id !== 0));
  }, []);

  useEffect(() => {
    postsDateSource();
  }, [postsDateSource]);

  const [form, setForm] = useState<ShiftAutoFill>(initialForm);

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    setLoading(true);
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      await dispatch(shiftAutoFill.async(form));
      changeVisible(false);
      refresh();
    }
    setLoading(false);
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Автозаполнение"
        width={400}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Тип" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={types}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.type}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, type: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Тип" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Тип" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>
                        <AppFiledBox label="Дата" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, date: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            displayFormat="MM-yyyy"
                            value={form.date}
                            calendarOptions={{
                              maxZoomLevel: 'year',
                              minZoomLevel: 'century',
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={loading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default AutoFillModal;
